<template>
  <span>
    <template v-if="$i18n.locale==='ja'">
      {{ profile.last_name }}&nbsp;{{ profile.first_name }}
    </template>
    <template v-else>
      {{ profile.first_name }}&nbsp;{{ profile.last_name }}
    </template>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      profile: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      ...mapGetters(['ui'])
    }
  }
</script>

<style scoped>

</style>
